export enum PasswordChangeResult {
    Complexity,
    Duplicate,
    None,
    Success
}